module.exports = __webpack_public_path__ + "img/linghao-android.16b7f79d.png";